import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchUserTagData } from "../../actions/setUserTagData";

function useUserCardData({ id }) {
  const { userTagData } = useSelector((state) => state);
  const userData = userTagData[id]?.data || {};
  const dispatch = useDispatch();
  useEffect(() => {
    if (id) {
      dispatch(fetchUserTagData(id));
    }
  }, [id]);
  return {
    userData,
  };
}

export default useUserCardData;
